export default "__VITE_ASSET__CZDG8$em__"